import global from "./global.js";
const log = global.log.getLogger("f_mtac.Message");
// Message types
const MESSAGE_TYPE_SAISIE = 0;
const MESSAGE_TYPE_FLASH = 1;

//const MESSAGE_TYPE_LABELS = ["SAISIE","FLASH"];

// Message ACK state
const MESSAGE_ACK_NOT_READ = 0;
const MESSAGE_ACK_READ = 1;

export const MessageCollection = function () {
    var $messages_list = $("#messages-list");
    var N = 0; // total messages number

    this.remove = ({local_id}) => {
        let msg = document.getElementById(local_id);
        if (!msg) {
            return;
        }
        let rm = global.datastorage.get(msg, "dataMessage");
        // iterating over messages after the removed message
        for (let cn = rm.node.next(); cn.length !== 0; cn = cn.next()) {
            let cm = global.datastorage.get(cn[0], "dataMessage");
            cm.index -= 1;
        }
        rm.node.remove();
        N -= 1;
    };

    this.insert = (message_data) => {
        log.debug("Message insert:", message_data);
        if (document.getElementById(message_data.local_id)) {
            return;
        }
        var im = new Message(message_data); // inserted message
        for (let mn of $messages_list.find(".message")) {
            let cm = global.datastorage.get(mn, "dataMessage"); // current message
            if (im === null) {
                // Message already inserted. Updating index of following messages.
                cm.index += 1;
                continue;
            }
            if (im.tx_time < cm.tx_time) {
                // Insert message here.
                im.node.insertBefore(cm.node);
                im.index = cm.index;
                cm.index += 1;
                im = null;
                N += 1;
            }
        }
        if (im !== null) {
            // message not inserted
            N += 1;
            im.index = N;
            $messages_list.append(im.node);
        }
    };

    this.update = (message_data, modifications) => {
        log.debug("Message update:", message_data, modifications);
        let msg = document.getElementById(message_data.local_id);
        if (!msg) {
            return;
        }
        let um = global.datastorage.get(msg, "dataMessage"); // updated message
        if ("tx_time" in modifications) {
            //AGPOC-3330 : check if a log has been inserted between creation and tx_time update and move the log to the right place
            um.tx_time = modifications.tx_time;
            if (!global.datastorage.has(um.node.next(), "dataMessage")) {
                return;
            }
            let nextm = global.datastorage.get(um.node.next(), "dataMessage");
            if (nextm.tx_time < modifications.tx_time) {
                for (let cn = um.node.next(); cn.length !== 0; cn = cn.next()) {
                    let cm = global.datastorage.get(cn, "dataMessage");
                    cm.index -= 1;
                }
                um.node.remove();
                N -= 1;
                message_data.tx_time = modifications.tx_time;
                this.insert(message_data);
            }
        }
    };

    this.empty = () => {
        $messages_list.html("");
        N = 0;
    };

    this.getMessageNumber = () => {
        return N;
    };
};

export const Message = function ({local_id, sender_name, sender_login, text, type, ack, tx_time}) {
    let message_type = type === MESSAGE_TYPE_SAISIE ? "saisie" : "flash";
    let l_ack = ack; // local ack, 0 or 1 ; MESSAGE_ACK_READ or MESSAGE_ACK_NOT_READ

    Object.defineProperty(this, "type", {
        set: () => {},
        get: () => message_type
    });

    Object.defineProperty(this, "text", {
        set: () => {},
        get: () => text
    });

    Object.defineProperty(this, "sender_name", {
        set: () => {},
        get: () => sender_name
    });

    Object.defineProperty(this, "id", {
        set: () => {},
        get: () => local_id
    });

    Object.defineProperty(this, "index", {
        set: (value) => {
            message_index = value;
            $message_index.text(Message.number_format(message_index, 3));
        },
        get: () => message_index
    });

    Object.defineProperty(this, "ack", {
        set: (value) => {
            l_ack = value ? MESSAGE_ACK_READ : MESSAGE_ACK_NOT_READ;
            if (l_ack === MESSAGE_ACK_READ) {
                $message.addClass("read");
                $message_reading_status.removeClass("f_mtac-icon-circle-regular");
                $message_reading_status.addClass("f_mtac-icon-circle-check-solid");
            } else {
                $message.removeClass("read");
                $message_reading_status.removeClass("f_mtac-icon-circle-check-solid");
                $message_reading_status.addClass("f_mtac-icon-circle-regular");
            }
        },
        get: () => l_ack === MESSAGE_ACK_READ
    });

    Object.defineProperty(this, "node", {
        set: () => {},
        get: () => $message
    });

    Object.defineProperty(this, "tx_time", {
        set: (value) => {
            var message_tx_time = Message.date_format(value);
            $message_date.text(message_tx_time);
        },
        get: () => tx_time
    });
    var message_index = 0;

    /* 
    <div id="${local_id}" class="message read">
        <div class="message-index">
            <span>${message_index}</span>
            [<i class="f_mtac-icon-circle-exclamation-solid" display="none"></i>]
        </div>
        <div class="message-text">
            <span>Message content</p>
        </div>
        <div class="message-info">
            <span class="row">User name</span>
            <span class="row log-label-date">02/01/2022&nbsp17:11</span>
        </div>
        <i class="f_mtac-icon-circle-regular"></i>
        <i class="f_mtac-icon-circle-check-solid" display="none"></i>
    </div> 
    */

    var $message = $("<div />").attr({id: `${local_id}`, class: "message"});
    if (message_type === "flash") {
        $message.addClass("flash");
    } else {
        $message.addClass("saisie");
    }

    global.datastorage.put($message[0], "dataMessage", this);

    var $message_index_container = $("<div />").attr({class: "message-index"}).appendTo($message);
    var $message_index = $("<span />").appendTo($message_index_container);
    if (message_type === "flash") {
        $("<i />").attr({class: "f_mtac-icon-circle-exclamation-solid"}).appendTo($message_index_container);
    }

    var $message_content_container = $("<div />").attr({class: "message-content"}).appendTo($message);
    var $message_text_container = $("<div />").attr({class: "message-text"}).appendTo($message_content_container);
    for (let line of text.split("#§#")) {
        $("<span />").text(line).append("<br>").appendTo($message_text_container);
    }

    var $message_info_container = $("<div />").attr({class: "message-info"}).appendTo($message_content_container);
    $("<span />").text(sender_name).appendTo($message_info_container);
    var $message_date = $("<span />").text(Message.date_format(tx_time)).appendTo($message_info_container);

    var $message_reading_status_container = $("<div />").attr({class: "message-reading-status"}).appendTo($message);
    var $message_reading_status = $("<i class='f_mtac-icon-circle-regular'/>").appendTo($message_reading_status_container);
    if (l_ack === MESSAGE_ACK_READ || sender_login === global.configuration.user.login) {
        this.ack = true;
    } else {
        this.ack = false;
    }
};

Message.date_format = (time) => {
    let time_date = new Date(time / 1000);
    return `${global.internationalization.formatTime(time_date)} [${global.internationalization.formatDate(time_date)}]`;
};

Message.date_csv_format = (time) => {
    let time_date = new Date(time / 1000);
    let H = time_date.getHours();
    let M = time_date.getMinutes();
    return `${H >= 10 ? H : "0" + H}:${M >= 10 ? M : "0" + M}`;
};

Message.getExportData = (message) => {
    let array = [];
    array.push(Message.date_csv_format(message.tx_time));
    array.push(message.text);
    return array;
};

Message.getExportDate = () => {
    let time_date = new Date(Date.now());
    let D = time_date.getDate();
    let Mo = time_date.getMonth() + 1;
    let Y = time_date.getFullYear();
    return `${Y}${Mo >= 10 ? Mo : "0" + Mo}${D >= 10 ? D : "0" + D}`;
};

Message.number_format = (n, width) => String(n).padStart(width, "0");

Message.type = (type) => {
    switch (type) {
        case MESSAGE_TYPE_FLASH:
            //return "flash";
            return global.internationalization.text("logtab.flash");
        case MESSAGE_TYPE_SAISIE:
            //return "saisie";
            return global.internationalization.text("logtab.normal");
    }
};

Message.type_label = (type) => {
    switch (type) {
        case MESSAGE_TYPE_FLASH:
            return global.internationalization.text("logtab.FLASH");
        case MESSAGE_TYPE_SAISIE:
            return global.internationalization.text("logtab.NORMAL");
    }
};
